/* rr-variant-guard.js — RunRun 2026-09-22
 *
 * PROBLEMA
 * El PDP agregaba al carrito una variante distinta de la que muestra la pantalla.
 * Del video del user: con la 39 a la vista, el carrito respondía
 * "'Sandalias con plataforma Zebzag de Nubuck - 36' está agotado".
 * Reproducido en producción el 22-sep-2026. En MX el carrito llegó a recibir
 * "Botas 1460 - Black / 22 CM" cuando en pantalla se había elegido Rojo Cereza / 27 CM:
 * color equivocado Y talla equivocada, sin ningún mensaje de error.
 *
 * QUÉ PASA
 * Al hacer clic en un swatch de color de un combined listing:
 *  - variant-picker.js llama updateMain() y NUNCA dispara VariantUpdateEvent, así que
 *    product-form.js jamás corrige input[name=id].
 *  - el morph actualiza h1, precio, fotos y los data-variant-id, pero NO re-renderiza los
 *    botones de talla: conservan el value y el :checked del producto anterior.
 *  - por eso el radio :checked MIENTE después de un cambio de color.
 * Lo único confiable es el data-variant-id del control sobre el que el usuario hizo clic.
 *
 * QUÉ HACE ESTE GUARD (no modifica el theme, sólo el campo que viaja al carrito)
 *  1. Sigue el clic real del usuario sobre una opción y guarda su data-variant-id.
 *  2. Lo escribe en input[name=id] al instante, así queda bien también para los botones de
 *     wallet (Apple Pay / Shop Pay), que leen el form sin disparar submit.
 *  3. En el submit (fase de captura, antes que product-form.js) revalida:
 *     - si hubo cambio de color y todavía no se eligió talla, BLOQUEA y avisa, porque en ese
 *       estado lo que se ve no es lo que se agregaría;
 *     - si la opción elegida no tiene variante detrás (valores fantasma como "36 CL" y
 *       "46 CL" del 1460 verde), BLOQUEA y avisa.
 *
 * CRITERIO: nunca pisa ni vacía el campo sin tener algo mejor. Si no sabe, deja el
 * comportamiento actual del theme intacto, para no poder frenar una venta sana.
 *
 * Rollback: borrar la línea <script> de layout/theme.liquid. Backups en esta carpeta.
 */
(function () {
  'use strict';
  if (window.__rrVariantGuard) return;
  window.__rrVariantGuard = true;

  var SCOPE_SEL = '.shopify-section, dialog, product-card';
  var FORM_SEL = 'form[data-type="add-to-cart-form"]';

  /* Estado a nivel de página. No lo guardamos por elemento porque el morph del combined
     listing reemplaza el <variant-picker> y cualquier referencia se perdería. */
  var st = { has: false, id: '', label: '', switched: false, navegando: false };

  function scopeOf(el) {
    return (el && el.closest && el.closest(SCOPE_SEL)) || document;
  }

  function hiddenInput(form) {
    return form.querySelector('input[name="id"]');
  }

  /* Un control de opción del picker se reconoce por data-option-value-id. Eso deja fuera
     cualquier control del modal de guía de tallas sin tener que adivinar su anidamiento
     (los radios de talla viven dentro de <dialog-component>, así que no sirve excluir por ahí). */
  function isOptionControl(el) {
    return !!(el && el.dataset && el.dataset.optionValueId);
  }

  function isProductSwitch(el) {
    var url = el.dataset ? el.dataset.connectedProductUrl : '';
    if (!url) return false;
    return url.split('?')[0] !== window.location.pathname;
  }

  function labelOf(el) {
    var lb = el.closest ? el.closest('label') : null;
    var t = lb && lb.querySelector('[data-key="variant-option-text"]');
    var txt = (t && t.textContent) || el.value || (el.getAttribute && el.getAttribute('aria-label')) || '';
    return String(txt).trim();
  }

  function writeAll(id) {
    if (!id) return;
    var forms = document.querySelectorAll(FORM_SEL);
    for (var i = 0; i < forms.length; i++) {
      if (forms[i].closest('product-card')) continue;
      var inp = hiddenInput(forms[i]);
      if (inp && inp.value !== id) inp.value = id;
    }
    recheck(id);
  }

  /* El mismo re-render mueve el :checked a otra talla (medido: al elegir "39 CL" la marca
     saltaba a "41 CL"). Volvemos a marcar el botón que corresponde a la variante elegida,
     para que lo que se ve sea lo que se compra. Asignar .checked no dispara change, así que
     no se realimenta. */
  function recheck(id) {
    var picker = document.querySelector('variant-picker');
    if (!picker) return;
    var radios = picker.querySelectorAll('fieldset.variant-option input[type="radio"]');
    for (var i = 0; i < radios.length; i++) {
      var r = radios[i];
      if (!isOptionControl(r)) continue;
      if (r.dataset.variantId === id && !r.checked) { r.checked = true; return; }
    }
  }

  /* ------------------------------------------------------------------------------------
     REPARAR EL SELECTOR CUANDO EL RE-RENDER LO DEJA MUERTO

     Medido en producción el 22-sep-2026 sobre "Botas 1460 Pascal de cuero Ambassador"
     (combined listing): basta con elegir una talla, sin tocar el color, para que el
     re-render de sección devuelva las 9 tallas TACHADAS y sin data-variant-id. El cliente
     ve todo agotado y no puede seguir. Pasa porque el pedido de sección manda el valor de
     color del producto PADRE contra el producto hijo, y Shopify no resuelve ninguna variante.

     Antes de cada cambio guardamos el estado bueno del bloque de tallas. Si el re-render lo
     deja sin una sola variante viva, lo devolvemos a como estaba y re-aplicamos la talla que
     el usuario había elegido. Sólo restauramos cuando el estado nuevo está completamente
     muerto, así un render legítimo nunca se pisa.
     ------------------------------------------------------------------------------------ */
  var snapHtml = null, snapVivos = 0, repairTimers = [];

  function ultimoFieldset() {
    var p = document.querySelector('variant-picker');
    if (!p) return null;
    var fss = p.querySelectorAll('fieldset.variant-option');
    return fss.length ? fss[fss.length - 1] : null;
  }
  function vivos(fs) {
    if (!fs) return 0;
    var rs = fs.querySelectorAll('input[type="radio"]'), n = 0;
    for (var i = 0; i < rs.length; i++) if (isOptionControl(rs[i]) && rs[i].dataset.variantId) n++;
    return n;
  }
  function guardarSnapshot() {
    var fs = ultimoFieldset(); if (!fs) return;
    var v = vivos(fs);
    if (v > 0) { snapHtml = fs.innerHTML; snapVivos = v; }
  }
  function repararSiMuerto() {
    for (var i = 0; i < repairTimers.length; i++) clearTimeout(repairTimers[i]);
    repairTimers = [];
    [300, 800, 1500, 2500, 4000].forEach(function (ms) {
      repairTimers.push(setTimeout(function () {
        var fs = ultimoFieldset();
        if (!fs || !snapHtml || snapVivos === 0) return;
        if (vivos(fs) > 0) return;               // el render está sano: no tocamos nada
        fs.innerHTML = snapHtml;                 // devolvemos el bloque de tallas que servía
        if (st.has && st.id) { recheck(st.id); writeAll(st.id); }
        clearWarnAll();
      }, ms));
    });
  }

  function remember(el) {
    if (st.navegando) return;
    if (!isOptionControl(el)) return;
    if (el.closest && el.closest('product-card')) return;

    if (isProductSwitch(el)) {
      st = { has: false, id: '', label: '', switched: true };
      return;
    }
    repararSiMuerto();
    st = { has: true, id: (el.dataset.variantId || ''), label: labelOf(el), switched: st.switched };
    if (st.id) { clearWarnAll(); writeAll(st.id); reassert(); }
    else reintentar();   // el DOM estaba a medio re-render: reintentamos en vez de dar por muerta la talla
  }

  /* Al cambiar de color, el theme deja unos segundos con TODAS las tallas tachadas y sin
     data-variant-id. Si el usuario hace clic justo en esa ventana no hay que declarar la talla
     agotada: se vuelve a leer el DOM hasta que se recompone. Sólo si sigue sin resolver al
     momento de agregar al carrito se bloquea. */
  var retries = [];
  function resolverDelDom() {
    var picker = document.querySelector('variant-picker');
    if (!picker) return '';
    var fss = picker.querySelectorAll('fieldset.variant-option');
    if (!fss.length) return '';
    var ck = fss[fss.length - 1].querySelector('input[type="radio"]:checked');
    if (ck && isOptionControl(ck) && ck.dataset.variantId) return ck.dataset.variantId;
    // si nada quedó marcado, buscamos el botón cuyo texto coincide con lo que eligió el usuario
    if (st.label) {
      var rs = fss[fss.length - 1].querySelectorAll('input[type="radio"]');
      for (var i = 0; i < rs.length; i++) {
        if (isOptionControl(rs[i]) && labelOf(rs[i]) === st.label && rs[i].dataset.variantId) {
          return rs[i].dataset.variantId;
        }
      }
    }
    return '';
  }
  function reintentar() {
    for (var i = 0; i < retries.length; i++) clearTimeout(retries[i]);
    retries = [];
    [150, 400, 900, 1600, 2600, 4000, 6000].forEach(function (ms) {
      retries.push(setTimeout(function () {
        if (!st.has || st.id) return;
        var id = resolverDelDom();
        if (!id) return;
        st.id = id; clearWarnAll(); writeAll(id); reassert();
      }, ms));
    });
  }

  function clearWarnAll() {
    var m = document.querySelectorAll('.rr-variant-guard-msg');
    for (var i = 0; i < m.length; i++) if (m[i].parentNode) m[i].parentNode.removeChild(m[i]);
  }

  /* El re-render de sección del theme vuelve a pisar input[name=id] ~1,5 s después de cada
     clic en una talla, y lo deja en la PRIMERA variante del producto. Medido en CL: al elegir
     "39 CL" el campo quedaba correcto al instante y a los 1500 ms volvía a la 36, además de
     mover el :checked a "41 CL". Por eso reafirmamos el valor durante unos segundos. */
  var timers = [];
  function reassert() {
    for (var i = 0; i < timers.length; i++) clearTimeout(timers[i]);
    timers = [];
    var mine = st.id;
    [200, 600, 1200, 2000, 3200, 5000].forEach(function (ms) {
      timers.push(setTimeout(function () {
        if (st.has && st.id === mine) writeAll(mine);
      }, ms));
    });
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t) return;
    // el DOM todavía está sano en fase de captura: es el momento de guardar el respaldo
    if (isOptionControl(t) && !(t.closest && t.closest('product-card'))) guardarSnapshot();
    if (t.tagName === 'SELECT') {
      var opt = t.selectedOptions && t.selectedOptions.length ? t.selectedOptions[0] : null;
      if (opt) remember(opt);
      return;
    }
    if (t.tagName === 'INPUT' && t.type === 'radio') remember(t);
  }, true);

  /* --------------------------------------------------------------------------------------
     CAMBIO DE COLOR = NAVEGACIÓN REAL, NO MORPH

     Medido en producción el 22-sep-2026: cuando el swatch de color lleva a otro producto
     (combined listing), variant-picker.js hace updateMain() y el bloque de tallas NO se
     re-renderiza. Quedan el value, el :checked y hasta el data-variant-id del producto
     anterior. En MX, tras elegir Rojo Cereza y hacer clic en el botón rotulado "27 CM", el
     carrito recibía "Botas 1460 - Black / 26 CM": color y talla equivocados, sin aviso.

     En ese estado no hay dato confiable en el DOM para corregir nada desde el cliente. Así
     que interceptamos el clic y navegamos al producto de verdad. La página se arma en el
     servidor, completa y correcta. Vamos a la URL limpia, sin ?variant=, para que no se
     preseleccione una talla y el CTA diga "Elige tus opciones", que es justo lo que busca el
     fix CRO del 22-may. Cuesta una recarga al cambiar de color; a cambio nunca se vende una
     talla que el cliente no eligió.
     -------------------------------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('product-card')) return; // el PLP tiene su propio flujo de tarjeta

    var lb = t.closest('label');
    var input = null;
    if (t.tagName === 'INPUT' && t.type === 'radio') input = t;
    else if (lb) input = lb.querySelector('input[type="radio"]');
    if (!input || !isOptionControl(input) || !isProductSwitch(input)) return;

    var dest = String(input.dataset.connectedProductUrl || '').split('?')[0];
    if (!dest) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    st = { has: false, id: '', label: '', switched: true, navegando: true };
    bloquearCompra();
    window.location.assign(dest);
  }, true);

  /* El espejo de la talla frontera (rr-sz-mirror) no tiene input propio: delega el clic al
     radio real, así que lo leemos en el tick siguiente. */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var mirror = t.closest('.rr-sz-mirror');
    if (!mirror) return;
    setTimeout(function () {
      var picker = document.querySelector('variant-picker');
      if (!picker) return;
      var fss = picker.querySelectorAll('fieldset.variant-option');
      if (!fss.length) return;
      var ck = fss[fss.length - 1].querySelector('input[type="radio"]:checked');
      if (ck) remember(ck);
    }, 30);
  }, true);

  /* --------------------------------------------------------------------------------------
     BLOQUEO MIENTRAS CARGA EL OTRO COLOR

     Medido en el video de MX del 22-sep 18:37: tras tocar el swatch del otro color, la página
     nueva tarda en llegar y la vieja sigue en pantalla y operable. El cliente tocó una talla y
     "Agregar" en ese lapso y el carrito recibió el color ANTERIOR (Rojo Cereza con la pantalla
     en Black). Congelamos selector y botones hasta que cambie la página.
     -------------------------------------------------------------------------------------- */
  var ZONAS = 'variant-picker, .product-form-buttons, .accelerated-checkout-block, shopify-accelerated-checkout, .shopify-payment-button, product-form-component';
  var lockTimer = null;
  function bloquearCompra() {
    var z = document.querySelectorAll(ZONAS);
    for (var i = 0; i < z.length; i++) {
      z[i].setAttribute('data-rr-lock', '1');
      z[i].style.pointerEvents = 'none';
      z[i].style.opacity = '0.55';
      z[i].setAttribute('aria-busy', 'true');
    }
    var bs = document.querySelectorAll('form[data-type="add-to-cart-form"] button');
    for (var j = 0; j < bs.length; j++) { bs[j].setAttribute('data-rr-was-disabled', bs[j].disabled ? '1' : '0'); bs[j].disabled = true; }
    if (lockTimer) clearTimeout(lockTimer);
    lockTimer = setTimeout(desbloquear, 12000);   // red de seguridad si la navegación no ocurre
  }
  function desbloquear() {
    var z = document.querySelectorAll('[data-rr-lock]');
    for (var i = 0; i < z.length; i++) {
      z[i].removeAttribute('data-rr-lock');
      z[i].style.pointerEvents = '';
      z[i].style.opacity = '';
      z[i].removeAttribute('aria-busy');
    }
    var bs = document.querySelectorAll('button[data-rr-was-disabled]');
    for (var j = 0; j < bs.length; j++) { bs[j].disabled = bs[j].getAttribute('data-rr-was-disabled') === '1'; bs[j].removeAttribute('data-rr-was-disabled'); }
    st.navegando = false;
  }
  // volver atrás desde el otro color restaura esta página desde la caché: la liberamos
  window.addEventListener('pageshow', function (e) { if (e.persisted) desbloquear(); });

  /* backstop en el submit ------------------------------------------------------------------ */
  function warn(form, text) {
    var host = scopeOf(form).querySelector('variant-picker') || form;
    var msg = host.querySelector('.rr-variant-guard-msg');
    if (!msg) {
      msg = document.createElement('p');
      msg.className = 'rr-variant-guard-msg';
      msg.setAttribute('role', 'alert');
      msg.setAttribute('aria-live', 'assertive');
      msg.style.cssText = 'margin:.5rem 0 0;color:#c00;font-size:.875rem;line-height:1.35';
      host.appendChild(msg);
    }
    msg.textContent = text;
    try { host.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (err) {}
  }

  function clearWarn(form) {
    var msg = scopeOf(form).querySelector('.rr-variant-guard-msg');
    if (msg && msg.parentNode) msg.parentNode.removeChild(msg);
  }

  /* El botón de agregar no siempre pasa por el evento submit: el theme tiene su propio
     on:click. Reafirmamos el valor en la captura del clic, antes que corra nada del theme. */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var btn = t.closest('button[type="submit"], [ref="addToCartButton"]');
    if (!btn) return;
    if (st.navegando) { e.preventDefault(); e.stopImmediatePropagation(); return; }
    var form = btn.closest(FORM_SEL);
    if (!form || form.closest('product-card')) return;
    if (!scopeOf(form).querySelector('variant-picker')) return;

    // último intento antes de bloquear: puede que el DOM ya se haya recompuesto
    if (st.has && !st.id) { var rid = resolverDelDom(); if (rid) { st.id = rid; clearWarnAll(); } }

    if (st.has && st.id) {
      var inp = hiddenInput(form);
      if (inp && inp.value !== st.id) inp.value = st.id;
      clearWarn(form);
      return;
    }
    // Mismos bloqueos que en el submit: el theme agrega por su propio on:click y ahí el
    // evento submit no siempre llega.
    if (st.has && !st.id) {
      e.preventDefault(); e.stopImmediatePropagation();
      warn(form, 'La talla ' + (st.label || 'elegida') + ' todavía se está cargando para este color. Volvé a tocarla y agregá de nuevo.');
      return;
    }
    if (st.switched) {
      e.preventDefault(); e.stopImmediatePropagation();
      warn(form, 'Elige tu talla para este color antes de agregar al carrito.');
    }
  }, true);

  function bootSnapshot(){ guardarSnapshot(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootSnapshot);
  else bootSnapshot();
  setTimeout(bootSnapshot, 900);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches(FORM_SEL)) return;
    if (st.navegando) { e.preventDefault(); e.stopImmediatePropagation(); return; }
    if (form.closest('product-card')) return;

    var picker = scopeOf(form).querySelector('variant-picker');
    if (!picker) return; // producto sin opciones: no intervenimos

    var input = hiddenInput(form);
    if (!input) return;

    // último intento antes de bloquear: puede que el DOM ya se haya recompuesto
    if (st.has && !st.id) { var rid = resolverDelDom(); if (rid) { st.id = rid; clearWarnAll(); } }

    if (st.has && st.id) {
      if (input.value !== st.id) input.value = st.id;
      clearWarn(form);
      return;
    }

    if (st.has && !st.id) {
      e.preventDefault(); e.stopImmediatePropagation();
      warn(form, 'La talla ' + (st.label || 'elegida') + ' todavía se está cargando para este color. Volvé a tocarla y agregá de nuevo.');
      return;
    }

    if (st.switched) {
      // Cambió el color y todavía no se eligió talla: el selector sigue mostrando las tallas
      // del color anterior, así que lo que se agregaría no es lo que se ve.
      e.preventDefault(); e.stopImmediatePropagation();
      warn(form, 'Elige tu talla para este color antes de agregar al carrito.');
      return;
    }

    clearWarn(form);
  }, true);
})();
